import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../mobile.setup';
import {
  MobileGroupsGroupManagementTab,
  MobileGroupsGroupMetricsTab,
} from './tabs';

const parent = Mobile.pages.groups;
const title = 'PAGE.MOBILE.GROUPS.TITLE';
const tabs: TabPermission[] = [
  MobileGroupsGroupManagementTab,
  MobileGroupsGroupMetricsTab
];

export const MobileGroupsPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
